import { render } from "./department.vue?vue&type=template&id=896c4b70&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"

import "./department.vue?vue&type=style&index=0&id=896c4b70&scoped=true&lang=css"
import "./department.vue?vue&type=style&index=1&id=896c4b70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-896c4b70"

export default script